import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimgs from "../../../assets/gameDevLeftImg.png";
import rightimgs from "../../../assets/gameDevRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import gameDevBenefitsImg1 from "../../../assets/gameDevBenefitsImg1.png";
import gameDevBenefitsImg2 from "../../../assets/gameDevBenefitsImg2.png";
import gameDevBenefitsImg3 from "../../../assets/gameDevBenefitsImg3.png";
import gameDevBenefitsImg4 from "../../../assets/gameDevBenefitsImg4.png";
import gameDevBenefitsImg5 from "../../../assets/gameDevBenefitsImg5.png";
import gameDevBenefitsImg6 from "../../../assets/gameDevBenefitsImg6.png";
import gameDevBenefitsImg7 from "../../../assets/gameDevBenefitsImg7.png";
import gameDevBenefitsImg8 from "../../../assets/gameDevBenefitsImg8.png";
import gameDevBenefitsImg9 from "../../../assets/gameDevBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import gameDevFunActivitiesImg1 from "../../../assets/gameDevFunActivitiesImg1.png";
import gameDevFunActivitiesImg2 from "../../../assets/gameDevFunActivitiesImg2.png";
import gameDevFunActivitiesImg3 from "../../../assets/gameDevFunActivitiesImg3.png";
import gameDevFunActivitiesImg4 from "../../../assets/gameDevFunActivitiesImg4.png";
import gameDevFunActivitiesImg5 from "../../../assets/gameDevFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

const UnityGameDevPortal = () => {
  const gamedevpage = heroContent.unitygamedevpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "5",
      description:
        "Unity Basics- Control objects with scripts, variables & operators.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "5",
      description:
        "Basics of Game Development- Build keyboard-controlled games using conditions & functions.",
    },
    {
      title: "Module 3",
      activities: "10",
      classes: "5",
      description:
        "Advanced Game Development- Add effects, sound, and create a scrolling runner game.",
    },
  ];

  const benefitsData = [
    {
      title: "Master C# Basics",
      description:
        "Grasp core C# concepts from scratch — no prior coding required.",
      icon: "Polymath-images/gameDevBenefitsImg1.png",
    },
    {
      title: "Explore Unity Platform",
      description:
        "Get hands-on with Unity tools and workspace for game creation.",
      icon: "Polymath-images/gameDevBenefitsImg2.png",
    },
    {
      title: " Write Game Scripts",
      description:
        "Learn how to code movement, logic, and interactions using C#.",
      icon: "Polymath-images/gameDevBenefitsImg3.png",
    },
    {
      title: "Use Variables Effectively",
      description:
        "Understand and apply variables and data types in real projects.",
      icon: "Polymath-images/gameDevBenefitsImg4.png",
    },
    {
      title: "Apply Game Logic",
      description:
        "Implement conditions, comparisons, and arithmetic in your game code.",
      icon: "Polymath-images/gameDevBenefitsImg5.png",
    },
    {
      title: "Control Game Objects",
      description:
        "Script object movement using keyboard inputs for interactive gameplay.",
      icon: "Polymath-images/gameDevBenefitsImg6.png",
    },
    {
      title: "Create Endless Gameplay",
      description:
        "Add repeating backgrounds for immersive, continuous game scenes.",
      icon: "Polymath-images/gameDevBenefitsImg7.png",
    },
    {
      title: "Enhance with Audio",
      description:
        "Integrate sound effects and music to boost game engagement.",
      icon: "Polymath-images/gameDevBenefitsImg8.png",
    },
    {
      title: "Develop Complete Games",
      description:
        "Combine skills to build, test, and polish your own playable games.",
      icon: "Polymath-images/gameDevBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "Catch The Food Game",
      image: "Polymath-images/gameDevFunActivitiesImg1.png",
    },
    {
      title: "Runner Game",
      image: "Polymath-images/gameDevFunActivitiesImg2.png",
    },
    {
      title: "Car Racing Game",
      image: "Polymath-images/gameDevFunActivitiesImg3.png",
    },
    {
      title: "Falling Balls Game",
      image: "Polymath-images/gameDevFunActivitiesImg4.png",
    },
    {
      title: "Airplane Game",
      image: "Polymath-images/gameDevFunActivitiesImg5.png",
    },
  ];

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
      leftImg={'Polymath-images/gameDevLeftImg.png'}
      rightImg={'Polymath-images/gameDevRightImg.png'}
      titlePart1="Game Development"
      titlePart2="(Unity) Course"
      description="Kids love to play interactive games and its more fun to develop your own imaginative game.Polymath-kids offer a comprehensive online course i.e.Game Development using Unity platform for kids aged 12-18 years."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Game Development (Unity)"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Game Development"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default UnityGameDevPortal;
